import React from "react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import GetAppIcon from "@material-ui/icons/GetApp";
import Logo from "../../../assets/icon/Logo";

var MobileDetect = require("mobile-detect");

function NotifHeader() {
  var md = new MobileDetect(window.navigator.userAgent);
  console.log(md.os());
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#AABBE9",
        height: "40px",
        padding: "10px",
        color: "white",
      }}
    >
      <div>
        <Logo width="100" />
      </div>
      <div>
        <Button
          size="small"
          endIcon={<GetAppIcon style={{ color: "white" }} />}
          onClick={() =>
            md.os() == "iOS"
              ? window.open(
                  "https://apps.apple.com/id/app/tokorame-reseller-app/id1551592750?l=id#?platform=iphone"
                )
              : window.open(
                  "https://play.google.com/store/apps/details?id=com.tokorame.resellerapp"
                )
          }
        >
          <Typography style={{ fontSize: "9px", color: "white" }}>
            Download Aplikasi Tokorame
          </Typography>
        </Button>
      </div>
    </div>
  );
}

export default NotifHeader;
